// main.tsx - Versión Corregida

import { prepararIdioma } from './i18n' // primero: fija el idioma antes de que nada se calcule
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'

// El catálogo del idioma antes que el resto de la aplicación (plan de idioma): las pantallas se
// importan después, así los textos que se calculan al cargar (listas de opciones, etiquetas)
// ya salen en el idioma del usuario, y en inglés no se ve un instante en español.
prepararIdioma().finally(async () => {
  const [{ default: App }, { AuthProvider }] = await Promise.all([
    import('./App.tsx'),
    import('./contexts/AuthContext'),
  ])
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>,
  )
})
